export function OutlineSearchCompanyIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2203 13.3794C16.7653 12.381 17.0691 11.2428 17.0691 10.0322C17.0691 6.14952 13.9196 3 10.037 3C6.15434 3 3 6.14952 3 10.0322C3 13.9148 6.14952 17.0691 10.037 17.0691C11.2476 17.0691 12.3859 16.7653 13.3842 16.2251L18.1592 21L21 18.1592L16.2203 13.3794Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.95972 13.0465V7.6253C6.95972 7.2925 7.23946 7.01758 7.5819 7.01758H12.487C12.8295 7.01758 13.1092 7.28767 13.1092 7.6253V13.0465"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.0369 13.0462V12.043"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M10.0369 11.0393V10.0312"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
